import React, {
  useEffect,
} from 'react';

import {
  useLocation,
} from 'react-router-dom';

import {
  useStore,
} from '../../store';

import {
  documentColumns,
} from '../../utils/columns';

import {
  DataTable,
} from '../../components';

export function Document() {
  const location = useLocation();

  const {
    document,
    config,
  } = useStore();

  useEffect(() => {
    if( location.pathname === '/documents')
      document.loadDocuments(config.data);

  }, [ location ]);

  return (
    <DataTable
      title="Documentos"
      columns={ documentColumns }
      store={ document }
    />
  );
};
